@let kioskCheckInMode = kioskCheckInMode$();
<div id="notifications-container" class="notifications-container" style="display: none"></div>

<div azavista-shared-camera-container class="azavista-shared-camera-container full-screen" [ngClass]="{ 'display-none': !showCamera }">
    <div class="azavista-shared-scan-container">
        <div class="azavista-vertical-stack shared-video-with-actions-container">
            <video #scanQrCodeVideoElement class="azavista-shared-video-element"></video>
            <div class="azavista-shared-scan-actions">
                <div class="azavista-horizontal-stack">
                    <azavista-button (click)="onToggleCamera()" class="azavista-onsite-button">
                        <span translate>TOGGLE_CAMERA</span>
                    </azavista-button>
                    <azavista-button (click)="onCloseCamera()" class="azavista-onsite-button">
                        <span translate>CLOSE</span>
                    </azavista-button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="main-container" [ngClass]="containerClasses$ | async" [class.is-mobile]="mobileQuery.matches">
    <mat-toolbar color="accent" class="main-toolbar sidemenu-toolbar">
        <div class="main-toolbar-area">
            @if (mobileQuery.matches) {
                <button mat-icon-button class="toolbar-menu-button" (click)="onToolbarMenuButtonClick()" aria-label="Toggle navigation menu">
                    <mat-icon>menu</mat-icon>
                </button>
            }
        </div>

        <div class="main-toolbar-area">
            @if (isKioskCheckInModeVisible) {
            <div class="aoc-switch-container" style="margin-right: 12px">
                <button class="aoc-switch-btn" [class.aoc-switch-btn--active]="kioskCheckInMode === SwitchMode.badgePrintMode" (click)="onSwitchMode(SwitchMode.badgePrintMode)">
                    Badge print
                </button>
                <button class="aoc-switch-btn" [class.aoc-switch-btn--active]="kioskCheckInMode === SwitchMode.checkInMode" (click)="onSwitchMode(SwitchMode.checkInMode)">
                    Check in
                </button>
            </div>
            }
        </div>
        <aoc-navbar-profile></aoc-navbar-profile>
    </mat-toolbar>

    <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
        <!-- <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
            fixedTopGap="56">
            <mat-nav-list>
                <a mat-list-item routerLink="." *ngFor="let nav of fillerNav">{{nav}}</a>
            </mat-nav-list>
        </mat-sidenav> -->

        <mat-sidenav-content>
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
<aoc-customer-chatbot-close-button></aoc-customer-chatbot-close-button>
